"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EVoyageEnemyShipCommand = exports.EVoyageEnemyShipType = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var EVoyageEnemyShipType;
(function (EVoyageEnemyShipType) {
    EVoyageEnemyShipType[EVoyageEnemyShipType["Hammerhead"] = 0] = "Hammerhead";
})(EVoyageEnemyShipType = exports.EVoyageEnemyShipType || (exports.EVoyageEnemyShipType = {}));
var EVoyageEnemyShipCommand;
(function (EVoyageEnemyShipCommand) {
    EVoyageEnemyShipCommand[EVoyageEnemyShipCommand["Create"] = 0] = "Create";
    EVoyageEnemyShipCommand[EVoyageEnemyShipCommand["Destroy"] = 1] = "Destroy";
})(EVoyageEnemyShipCommand = exports.EVoyageEnemyShipCommand || (exports.EVoyageEnemyShipCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.EnemyShipCommand;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.command);
    messageWriter_sidecar_1.messageWriter.write8(m, d.type || 0);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        command: messageWriter_sidecar_1.messageWriter.read8(m),
        type: messageWriter_sidecar_1.messageWriter.read8(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        command: EVoyageEnemyShipCommand.Destroy,
        type: EVoyageEnemyShipType.Hammerhead,
    };
    messageWriter_sidecar_1.messageWriter.test('enemy-ship-command', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.command === EVoyageEnemyShipCommand.Destroy) {
        voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.networkDestroy(msg);
    }
    if (msg.command === EVoyageEnemyShipCommand.Create) {
        voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.createHammerheadClass();
    }
    //
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
